import { Component, HostBinding, Input } from '@angular/core';
import { NavigationItemType } from '@shared/enum/navigation-item-type';

// Dusk Warm: warmere, gedempte badge-kleuren i.p.v. de "pure" bootstrap-tokens
// (success-groen / primary-slate voelden te koel/fel op het warme oppervlak).
// Deze atom wordt enkel in de platformbeheer-trees/lijsten gebruikt, dus de
// blast-radius blijft beperkt. Zie docs/dusk-warm-redesign-implementation.md §5.15.
const colorConfig: { [key in NavigationItemType]: { bg: string; fg: string } } = {
  [NavigationItemType.Page]: { bg: '#4b413c', fg: '#ffffff' }, // warm dark taupe
  [NavigationItemType.Menu]: { bg: 'var(--secondary)', fg: '#ffffff' }, // warm taupe
  [NavigationItemType.AppRoot]: { bg: '#5f8f63', fg: '#ffffff' }, // gedempt warm sage
  [NavigationItemType.ClickThrough]: { bg: 'var(--elegant)', fg: 'var(--primary)' }, // amber
  [NavigationItemType.Unknown]: { bg: 'var(--between-highlight-and-separator)', fg: 'var(--primary)' }
};

@Component({
    selector: 'navigation-item-type-tag[type]',
    templateUrl: './navigation-item-type-tag.component.html',
    styleUrls: ['./navigation-item-type-tag.component.scss'],
    standalone: false
})
export class NavigationItemTypeTagComponent {
  @Input() type: NavigationItemType;

  @HostBinding('style.backgroundColor')
  get backgroundColor(): string {
    return colorConfig[this.type]?.bg;
  }

  @HostBinding('style.color')
  get textColor(): string {
    return colorConfig[this.type]?.fg;
  }
}
